export default {
  simplify_game: '后端无忧，让游戏开发更简单',
  ingame_desc:
    '专为游戏设计的全托管后端服务平台，帮助开发者低成本搭建高品质多人联机游戏',
  start_for_free: '开始试用',
  about_ingame: '快速了解',
  our_services: '服务能力',
  out_of_box: '20+后端服务，开箱即用',
  out_of_box_one: '20+开箱即用的游戏后端服务',
  out_of_box_two: '助力游戏创意落地',
  multiplayer_desc: '构建多人在线游戏生态，打造全平台优质联机游戏',
  economy_desc: '搭建游戏长线运营生态，实现游戏内的多场景商业化系统',
  content_desc: '全平台通用的内容分发技术，满足游戏的不同更新需求',
  analytics_desc:
    '提供从指标采集到监控告警的全链路数据分析系统，帮助开发者实时洞察游戏表现',
  engage_desc: '提升玩家参与度及游戏粘性',
  social_desc: '提供游戏社交服务，轻松实现玩家多场景跨平台互动',
  maximizing_your_reach: '跨平台、多引擎全方位支持',
  our_benifits: '服务优势',
  how_developers: '全周期赋能的游戏后端解决方案',
  streamlined_efficiency: '全流程提效',
  rapid_development: '缩短开发周期',
  rapid_development_desc: '服务插件化接入、多端互通，开发环境云化。',
  effortless_maintanance: '服务托管简化运维',
  effortless_maintanance_desc:
    '不限制云厂商，后端服务全托管，提供7*24的服务监控管理',
  effortless_maintanance_desc_two:
    '腾讯游戏服务质量保障，支持大规模用户并发、故障自动恢复及无损弹性伸缩',
  advanced_operations: '深化运营',
  advanced_operations_desc: '提供全面的数据分析、助力游戏运营。',
  enterprise_grade: '服务可靠',
  high_availability: '高可用',
  high_availability_desc: '采用分布式架构，支持故障自动恢复。',
  high_scalability: '高伸缩',
  high_scalability_desc: '支持无损弹性伸缩，根据需求动态调整资源。',
  high_performance: '高性能',
  high_performance_desc: '支持大规模并发，毫秒级响应。',
  battle_tested: '架构稳健',
  battle_tested_desc: '底层架构经过大量成熟腾讯游戏验证。',
  unlimited_flexibility: '使用灵活',
  cross_cloud: '不限云服务商',
  cross_cloud_desc: '支持亚马逊云、微软云、腾讯云等多家云服务商。',
  muilt_region: '不限发行地域',
  muilt_region_desc: '服务间支持跨洲通信。',
  microservice_customization: '服务可拓展',
  microservice_customization_desc: '基于微服务架构，支持自定义游戏逻辑。',
  global_service: '全球支持',
  global_support_tips: '全球化服务保障',
  service_deployment: '服务集群部署',
  service_deployment_desc: '支持玩家就近接入，保障全球玩家的游戏流畅体验',
  game_server_deployment: '游戏服部署：',
  cn_shanghai: '亚洲：中国 - 上海',
  na_virginia: '北美洲：美国 - 弗吉尼亚州',
  eu_frankfurt: '欧洲：德国 - 法兰克福',
  ap_singapore: '亚洲：新加坡',
  dediacated_server_deployment: '对战服部署：',
  deployed_globally: '支持全球可用区内拓展',
  global_team_support: '多地团队支持',
  global_team_support_desc:
    'InGame团队在英国、北美、马来西亚以及中国多地设有服务中心，提供方案咨询及技术支持，确保游戏业务的顺利接入使用',
  multi_country: '数据安全合规',
  multi_country_desc:
    '满足多国数据隐私法规，可提供符合当地的数据存储和数据处理方案，保障玩家信息安全',
  multilingual_support: '中英语言支持',
  multilingual_support_desc:
    '为用户提供具备中英双语版本的开发者门户、控制台及产品文档，支持来自不同地区的开发者使用',
  parnter_showcase: '合作伙伴',
  parnter_showcase_desc: '深受世界领先工作室信赖',
  security_assurance: '安全保障',
  security_statement: '安全声明',
  security_statement_desc:
    'InGame 遵循最高的信息安全和隐私保护标准，致力于保护信息系统、知识产权、客户数据免遭滥用或泄露',
  new_get_started: '立即试用',
  enter_email_address: '请输入您的邮箱地址',
  cost_effcient_development: '高效搭建游戏后端',
  cost_effcient_development_desc:
    '插件化接入游戏后端服务，开发者可根据需求灵活选用，同时支持通过自定义微服务拓展更多个性化游戏逻辑',
  data_driven_operation: '数据驱动游戏运营',
  data_driven_operation_desc:
    '提供全链路数据分析助力游戏洞察自身表现，并为开发者提供Mails、Goals、BattlePass等服务帮助快速触达玩家及响应玩家需求',
  enter_wecom_name: '请输入您的企业微信名称',
  ready_to_try: '准备好构建你的游戏了吗？',
  start_for_free_new: '立即试用',
  find_out_more: '详情',
};
